import React from "react";
import { IspirazionePageConfig } from "../../configuration";
import Content from "./Content";
import { makeStyles } from "@material-ui/core/styles";
import SwiperComponent from "./Swiper";
import BoxDecoration from "../Decorations/Box";
import { mobile } from "../mediaQueries";
import FadeInHOC from "../FadeInHOC";
import VisibilitySensor from "../VisibilitySensor";
import AssignId from "../AssignId";

const styles = (theme) => ({
  root: {
    padding: "120px 0 85px 0",
    display: "flex",
    position: "relative",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      padding: "33px 0 80px 0",
    },
  },
  position: {
    position: "relative",
  },
});

const useStyles = makeStyles(styles);

export default function Ispirazione({ setSlider }) {
  const classes = useStyles();
  return (
    <div className={classes.position}>
      <AssignId absolute y="0" yMobile="-50px" id="ispirazione" />
      {/* decorative vectors */}
      <BoxDecoration
        left="90%"
        right={0}
        top="30%"
        bottom={0}
        rotate="22.5deg"
        scale="1.5"
        z={0}
      />
      <BoxDecoration
        left="90%"
        right={0}
        top="30%"
        bottom={0}
        rotate="45deg"
        scale="1.5"
        z={0}
      />
      <BoxDecoration
        left="90%"
        right={0}
        top="30%"
        bottom={0}
        rotate="67.5deg"
        scale="1.5"
        z={0}
      />
      <BoxDecoration
        left="90%"
        right={0}
        top="30%"
        bottom={0}
        rotate="0deg"
        scale="1.5"
        z={0}
      />
      <div className={classes.root}>
        <Content
          primaryText={IspirazionePageConfig.content.primary}
          secondaryText={IspirazionePageConfig.content.secondary}
        />
        <VisibilitySensor index={1} />
        <FadeInHOC seconds={3.5}>
          <SwiperComponent
            slides={IspirazionePageConfig.carousel}
            setSlider={setSlider}
          />
        </FadeInHOC>
      </div>
    </div>
  );
}